import { Media } from "../models/media";
import { MediaDetail } from "../models/media-detail";
import { Reader } from "../models/reader";

export class Globals {
  public static get LastSelectedLibraryId(): number | undefined {
    const res = window.localStorage.getItem("libraryId");
    if (res) {
      return +res;
    }
  }
  public static set LastSelectedLibraryId(val: number | undefined) {
    if (val) window.localStorage.setItem("libraryId", val.toString());
  }

  private static _newMedia: MediaDetail;
  public static get NewMedia(): MediaDetail {
    return this._newMedia;
  }
  public static set NewMedia(val: MediaDetail) {
    this._newMedia = val;
  }

  private static _newReader: Reader;
  public static get NewReader(): Reader {
    return this._newReader;
  }
  public static set NewReader(val: Reader) {
    this._newReader = val;
  }

  // Rental Reader History (pageup/pagedown)
  public static RentalReaderHistory: Reader[] = [];
  public static RentalReaderHistorySelectedId = 0;
  // [pageup]
  public static readerSelectPrevious() {
    if (Globals.RentalReaderHistory.length > 0) {
      if (Globals.RentalReaderHistorySelectedId > 0)
        return Globals.RentalReaderHistory[
          --Globals.RentalReaderHistorySelectedId
        ];
      return Globals.RentalReaderHistory[Globals.RentalReaderHistorySelectedId];
    }
    return null;
  }
  // [pagedown]
  public static readerSelectNext() {
    if (Globals.RentalReaderHistory.length > 0) {
      if (
        Globals.RentalReaderHistorySelectedId + 1 <
        Globals.RentalReaderHistory.length
      )
        return Globals.RentalReaderHistory[
          ++Globals.RentalReaderHistorySelectedId
        ];
      return Globals.RentalReaderHistory[Globals.RentalReaderHistorySelectedId];
    }
    return null;
  }
  public static openNewReader(reader: Reader) {
    Globals.RentalReaderHistory.push(reader);
    Globals.RentalReaderHistorySelectedId =
      Globals.RentalReaderHistory.length - 1;
  }
}
